import * as React from "react"
import {Loader, Message} from "semantic-ui-react"
import {Booker, BookerFragFragment, Booking, BookingGutsFragment} from "../graphql/queries"
import {errorUnionToEither, handleError} from "../graphql/errors"
import {WithModalStore} from "../App"
import {UpdateBookingWizard} from "./UpdateBookingWizard"
import {GraphQL} from "../graphql"

interface OwnProps extends WithModalStore {
  bookingNumber: string
}

interface Props extends OwnProps, BookerProp, BookingProp {}

class BookingComponent extends React.Component<Props> {
  render() {
    const {modalStore, booking, booker} = this.props

    return <UpdateBookingWizard modalStore={modalStore} booking={booking} booker={booker} />
  }
}

interface BookerProp {
  booker: BookerFragFragment
}
interface BookingProp {
  booking: BookingGutsFragment
}

function WithBooking(props: OwnProps & BookerProp) {
  const {bookingNumber} = props
  return (
    <GraphQL.Query
      query={Booking}
      variables={{number: bookingNumber}}
      // Polling is scary at scale but it does keep the booking up to date given it is subject to
      // change by each of admin, driver and booker.  And the "cache-and-network" fetch policy
      // ensure it is also updated whenever it is navigated to.
      pollInterval={180 * 1000}
      fetchPolicy="cache-and-network"
      render={({data}) => {
        if (data) {
          const {booking} = data
          if (booking) {
            return handleError(errorUnionToEither(booking), (booking) => (
              <BookingComponent {...props} booking={booking} />
            ))
          } else {
            return <div>No such booking found.</div>
          }
        } else {
          return <Loader active />
        }
      }}
    />
  )
}

function WithBooker(props: OwnProps) {
  return (
    <GraphQL.Query
      query={Booker}
      variables={{}}
      render={({data}) => {
        if (data !== null) {
          return handleError(errorUnionToEither(data.booker), (booker) => {
            if (booker.booker !== null) {
              return <WithBooking {...props} booker={booker.booker} />
            }
            return <Message error>Please log in to see this booking.</Message>
          })
        }
        // This should not happen, as Booker is loaded in InitializeSession
        return <Loader active />
      }}
    />
  )
}

export {WithBooker as Booking}



// WEBPACK FOOTER //
// ./src/components/Booking.tsx